export const countHR = (count: number) => {
  const MILLION = 1000000;
  const THOUSAND = 1000;

  if (count >= MILLION) {
    return `${(count / MILLION).toFixed(1)}M`;
  } else if (count >= THOUSAND) {
    return `${Math.round(count / THOUSAND)}K`;
  } else {
    return count;
  }
};
